<template>
  <v-container fluid>
    <v-row class="px-0" no-gutters>
      <v-col class="ma-1">
        <v-btn block v-bind="btnColor(1)" @click="setRequired('gross')">Gross income</v-btn>
      </v-col>
      <v-col class="ma-1">
        <v-btn block v-bind="btnColor(0)" @click="setRequired('takehome')">Take-home</v-btn>
      </v-col>
    </v-row>

    <v-row class="px-3 mt-3">
      <v-col cols="12">
        <v-row class="px-0" style="background: transparent">
          <v-card class="mx-auto panel-salary" outlined v-if="!isReqTakehome">
            <v-row>
              <v-col class="pl-6">
                <span class="body-2">Enter your gross annual salary:</span>
              </v-col>
              <v-col class="mr-3 mt-1">
                <v-text-field
                  class="my-text-center font-weight-medium"
                  :value="displayGross"
                  @change="v => displayGross = v"
                  solo
                  dense
                  clearable
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>

          <v-card class="mx-auto panel-salary" outlined v-if="isReqTakehome">
            <v-row>
              <v-col class="pl-6">
                <span class="body-2">Enter your required take-home per month:</span>
              </v-col>
              <v-col class="mr-3 mt-1">
                <v-text-field
                  class="my-text-center font-weight-medium"
                  :value="displayTakeHome"
                  @change="v => displayTakeHome = v"
                  solo
                  dense
                  clearable
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>
        </v-row>
      </v-col>
    </v-row>
    <v-card class="px-0" color="white">
      <v-card-text class="my-text-center font-weight-medium">
        <span v-if="isReqTakehome">
          You would need to earn
          <em>{{ displayGross }}</em> gross p.a.
        </span>
        <span v-if="!isReqTakehome">
          You're monthly take-home is
          <em>{{ displayTakeHome }}</em>
        </span>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    required: "gross"
    //gross: 50000
    // How much would you like your take-home to be?
    //
    // Required take-home  |  Required gross salary
    //
  }),
  methods: {
    setRequired(mode) {
      this.required = mode;
    },
    btnColor(i) {
      if (this.isReqTakehome && i == 0) return { color: "primary" };
      if (!this.isReqTakehome && i == 1) return { color: "primary" };
      return { color: "normal" };
    },
    cleanNumber(x) {
      let pos = x.indexOf(".");
      if (pos > -1) x = x.substring(0, pos);
      x = x.replace(/\D/g, "");
      return x;
    }
  },
  computed: {
    onMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    isReqTakehome() {
      return this.required == "takehome";
    },
    // labelTop() {
    //   if (this.isReqTakehome)
    //     return "Enter your required take-home salary per month:";
    //   return "Enter your gross annual salary:";
    // },
    labelSlider() {
      if (this.onMobile) return "Take-home (month):";
      return "Take-home (per month):";
    },
    displayGross: {
      get() {
        return this.$store.getters.getGrossIncome("yearly", 0);
      },
      set(newValue) {
        // first strip out any chars
        newValue = this.cleanNumber(newValue);
        this.$store.dispatch("setGrossIncome", newValue);

        // if (this.timeout) clearTimeout(this.timeout);
        // this.timeout = setTimeout(() => {
        //   this.$store.dispatch("setGrossIncome", newValue);
        // }, 300);
      }
    },
    displayTakeHome: {
      //return this.$store.getters.getTakeHome("monthly");
      get() {
        return this.$store.getters.getTakeHome("monthly", 2);
      },
      set(newValue) {
        // first strip out any chars
        newValue = this.cleanNumber(newValue);
        this.$store.dispatch("setTakeHome", newValue);

        // if (this.timeout) clearTimeout(this.timeout);
        // this.timeout = setTimeout(() => {
        //   this.$store.dispatch("setGrossIncome", newValue);
        // }, 300);
      }
    }
  }
};
</script>

<style>
.panel-salary {
  border: 2px solid rgb(172, 172, 172) !important;
  background-color: rgb(245, 247, 223) !important;
  /* padding: 14px; */
}
.panel-takehome {
  border: 2px solid maroon !important;
  background-color: yellow !important;
  /* font-size: large;   #d8d8d8 */
}

.my-text-center input {
  text-align: center !important;
}
</style>